(function () {
    'use strict';
    var jHtml = jQuery('html'),
        area = jHtml.data('area'),
        context = jHtml.data('state');
    jQuery.extend(true, e4.settings, {
        area: (function () {
            return area;
        })(),
        context: (function () {
            return context;
        })(),
        debug: {
            logWebVitals: false
        },
        middleware: {
            url: area + '/system/middelware'
        },

        handlebars: {
            helpers: {
                isLightOrDarkBg: {
                    limit: 155
                }
            }
        },
        pdf: {
            url: area + 'system/data/productsheet-generator',
            design: ''
        },
        activeCampaign: {
            url: area + '/system/data/active-campaign-api'
        },
        search: {
            result: {
                pages: {
                    show: false,
                    url: area + '/system/data/pages?q='
                },
                products: {
                    url: area + '/system/data/products?q=',
                    showAllLink: area + '/shop/search?q='.toLowerCase(),
                    max: {
                        xs: 4,
                        sm: 4,
                        md: 6,
                        lg: 8,
                        xl: 8
                    }
                }
            }
        },
        ecom: {
            filters: {
                url: area + '/system/data/productlist-filters'
            },
            products: {
                url: area + '/system/data/productlist-products'
            },
            relewiseFilters: {
                url: area + '/system/data/relewise-productlist-filters'
            },
            relewiseProducts: {
                url: area + '/system/data/relewise-productlist-products'
            },
            cart: {
                url: area + '/system/data/cart'
            },
            minicart:{
              url: `${area}/system/data/mini-cart`
            },
            quickorder: {
                url: area + '/system/data/products'
            },
            checkout: {
                url: area + '/system/data/checkout',
                termsAndConditions: area + '/shop/terms-and-conditions',
                designerTermsAndConditions: area + '/shop/designcart/terms-and-conditions',
                activeCampaignTerms: area + '/shop/active-campaign-terms'
            },
            product: {
                url: area + '/system/data/product-data'
            },
            variantCombinations: {
                url: area + '/system/data/variant-data'
            },
            parcelShops: {
                url: area + '/system/data/parcel-shops'
            },
            matrixModal: {
                url: area + '/system/data/matrix-modal'
            },
            download: {
                url: area + '/system/data/cart-download'
            },
            pdfmakeUrl: {
                url: '/files/templates/designs/identity_v2/_assets/js/vendor/pdfmake.min.js',
                fallback: '//cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.62/pdfmake.js',
                callback: null
            },
            vfsfontsUrl: {
                url: '/files/templates/designs/identity_v2/_assets/js/vendor/vfs_fonts.js',
                fallback: '//cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.62/vfs_fonts.js',
                callback: null
            }
        },
        dealersearch: {
            url: area + '/system/data/dealersearch',
            map: { styles: [{"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#d3d3d3"}]},{"featureType":"transit","stylers":[{"color":"#808080"},{"visibility":"off"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"visibility":"on"},{"color":"#b3b3b3"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"road.local","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"weight":1.8}]},{"featureType":"road.local","elementType":"geometry.stroke","stylers":[{"color":"#d7d7d7"}]},{"featureType":"poi","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#ebebeb"}]},{"featureType":"administrative","elementType":"geometry","stylers":[{"color":"#a7a7a7"}]},{"featureType":"road.arterial","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"road.arterial","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"landscape","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#efefef"}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"color":"#696969"}]},{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"visibility":"on"},{"color":"#737373"}]},{"featureType":"poi","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"road.arterial","elementType":"geometry.stroke","stylers":[{"color":"#d6d6d6"}]},{"featureType":"road","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{},{"featureType":"poi","elementType":"geometry.fill","stylers":[{"color":"#dadada"}]}] },
            marker: {
                typeSeparator: '_',
                iconUrl: '/files/templates/designs/identity_v2/_assets/img/googlemaps/',
                iconFileName: 'pin.png'
            },
            clusterer: {
                iconUrl: '/files/templates/designs/identity_v2/_assets/img/googlemaps/',
                iconFileName: '1.png'
            }
        },
        user: {
            impersonation: {
                url: area + '/system/data/users-impersonateable'
            }
        },
        require: {
            webVitals: {
                url: 'https://unpkg.com/web-vitals',
                fallback: 'https://unpkg.com/web-vitals',
                callback: null
            },
            datepicker: {
                url: '/Files/Templates/Designs/identity_v2/_assets/js/vendor/bootstrap-datepicker.js',
                fallback: '/Files/Templates/Designs/identity_v2/_assets/js/vendor/bootstrap-datepicker.js',
                callback: null
            },
            jQueryValidateMessages: {
                lang: 'en',
                url: 'https://cdnjs.cloudflare.com/ajax/libs/jquery-validate/1.19.1/localization/messages_{0}.min.js',
                fallback: '/files/system/espresso/design/_assets/js/vendor/jquery.validate.messages_{0}.js',
                callback: function () {
                    if (e4.settings.forms.validate.messages[e4.settings.require.jQueryValidateMessages.lang] !== undefined) {
                        jQuery.extend(jQuery.validator.messages, e4.settings.forms.validate.messages[e4.settings.require.jQueryValidateMessages.lang]);
                    }
                    jQuery.validator.addMethod('localenumber', function (value, domElm) {
                        var regExpLocaleNumber = new RegExp('^(?:-?\\d+|-?\\d{1,3}(?:\\' + e4.settings.separatorInteger + '\\d{3})+)?(?:\\' + e4.settings.separatorDecimal + '\\d+)?$');
                        return this.optional(domElm) || regExpLocaleNumber.test(value);
                    }, jQuery.validator.messages.number);

                    jQuery.validator.addMethod('email_dk', function (value, element) {
                        return this.optional(element) || /^[ÆØÅæøåA-Za-z0-9._%+-]+@(?:[ÆØÅæøåA-Za-z0-9-]+\.)+[A-Za-z]{2,6}$/.test(value);
                    }, jQuery.validator.messages.email);

                    jQuery.validator.methods.min = function (value, element, param) {
                        return this.optional(element) || e4.util.formatStringToJavascriptNumber(value) >= param;
                    };
                    jQuery.validator.methods.max = function (value, element, param) {
                        return this.optional(element) || e4.util.formatStringToJavascriptNumber(value) <= param;
                    };
                }
            },
            markerClusterer: {
                url: 'https://unpkg.com/@googlemaps/markerclusterer/dist/index.min.js',
                fallback: '/files/system/espresso/design/_assets/js/vendor/markerclusterer_compiled.js',
                callback: null
            },
        }
    });
}());